import SmallLink from "@components/global/new/SmallLink/SmallLink";
import WithModal from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import { useEffect, useRef } from "react";
import styles from "./CreatedTwoFA.module.scss";
import { CreatedTwoFAPropsI } from "./CreatedTwoFA.props";
import Field from "@components/global/new/Field/FieldEx";

function CreatedTwoFA({
  handleClose,
  fa,
  formatMessage,
  ...props
}: CreatedTwoFAPropsI) {
  const ref = useRef<HTMLImageElement>(null);
  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "auto";
    }
  }, [ref]);
  if (!fa) return null;
  return (
    <div className={styles.wrapper} ref={ref}>
      <div className={styles.head}>
        {formatMessage({ id: "modal.create_2fa.title" })}
      </div>
      <img
        className={styles.qr}
        src={`data:image/png;base64, ${fa.Qr}`}
        alt='watt manor'
      />
      <div className={styles.bottom}>
        <p>
          {formatMessage({ id: "modal.create_2fa.restore" })}
          <br />
          <Field
            className={styles.code}
            type='text'
            defaultValue={fa.Resetcode}
            readOnly
            disabled
            copy
          />
        </p>
        <p>{formatMessage({ id: "modal.create_2fa.loose" })}</p>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.CREATE_TWO_FA_MODAL, CreatedTwoFA, {
  NWC: true,
});
